import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { PageAggregationLogIndexResponse } from '@/repositories/generated';

const response: PageAggregationLogIndexResponse = {
  totalPages: 1,
  totalElements: 6,
  first: true,
  last: true,
  size: 1,
  content: [
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'TRANSACTION',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'DAILY',
      outputPattern: 'PREPAID_TOTAL',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'PROGRESS',
      filterItems: [],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'TRANSACTION',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'DAILY',
      outputPattern: 'CAMPAIGN_BREAKDOWN',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'PROGRESS',
      filterItems: [],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'TRANSACTION',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'DAILY',
      outputPattern: 'CHARGE',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'PROGRESS',
      filterItems: [],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'TRANSACTION',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'DAILY',
      outputPattern: 'SETTLEMENT',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'PROGRESS',
      filterItems: [],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'TRANSACTION',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'DAILY',
      outputPattern: 'SETTLEMENT_BY_CODE',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'PROGRESS',
      filterItems: [],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'CAMPAIGN',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'MONTHLY',
      outputPattern: 'CAMPAIGN',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'FAILURE',
      filterItems: ['WALLET_SERVICE', 'SHOP'],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'CAMPAIGN',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'YEARLY',
      outputPattern: 'CAMPAIGN',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'DONE',
      filterItems: ['CAMPAIGN'],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'CAMPAIGN',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'BULK_GRANT',
      outputPattern: 'CAMPAIGN',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'DONE',
      filterItems: ['BULK_GRANT'],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'BULK_GRANT',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'COMPANY',
      outputPattern: 'BULK_GRANT',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'DONE',
      filterItems: ['COMPANY'],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'BULK_GRANT',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'SHOP',
      outputPattern: 'BULK_GRANT',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'DONE',
      filterItems: ['SHOP'],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'BULK_GRANT',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'TERMINAL',
      outputPattern: 'BULK_GRANT',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'DONE',
      filterItems: ['TERMINAL'],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'BULK_GRANT',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'WALLET_SERVICE',
      outputPattern: 'BULK_GRANT',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'DONE',
      filterItems: ['WALLET_SERVICE', 'BULK_GRANT'],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'BULK_GRANT',
      aggregationStartDateTime: '2023-04-23T00:00:00+09:00',
      aggregationEndDateTime: '2023-05-23T00:00:00+09:00',
      criteria: 'BULK_GRANT',
      outputPattern: 'BULK_GRANT',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'DONE',
      filterItems: [],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'UNUSED_BALANCE',
      aggregationStartDateTime: '2023-04-01T00:00:00+09:00',
      aggregationEndDateTime: '2023-09-30T00:00:00+09:00',
      criteria: 'MONTHLY',
      outputPattern: 'UNUSED_BALANCE',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'PROGRESS',
      filterItems: ['WALLET_SERVICE'],
    },
    {
      id: '01G7BSJRS44QC70T7T96J70Q2K',
      aggregationCategory: 'UNUSED_BALANCE',
      aggregationStartDateTime: '2022-10-01T00:00:00+09:00',
      aggregationEndDateTime: '2023-03-31T00:00:00+09:00',
      criteria: 'WALLET_SERVICE',
      outputPattern: 'UNUSED_BALANCE',
      aggregatedAt: '2023-08-23T00:00:00+09:00',
      createdBy: '田中',
      aggregationStatus: 'PROGRESS',
      filterItems: [],
    },
  ],
  number: 1,
  sort: {
    empty: true,
    sorted: true,
    unsorted: true,
  },
  numberOfElements: 6,
  pageable: {
    offset: 1,
    sort: {
      empty: true,
      sorted: true,
      unsorted: true,
    },
    pageNumber: 1,
    pageSize: 1,
    paged: true,
    unpaged: true,
  },
  empty: true,
};

export const aggregation = http.get(
  createMockEndpoint('/aggregation'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
